import { LandingNav } from "@/components/landing/LandingNav";

export const Skel = ({ className = "" }) => <div className={`cx-skel rounded-xl ${className}`} />;

export const GridSkeleton = ({ n = 8, testid = "grid-skeleton" }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 mt-8 col-span-full" data-testid={testid}>
    {Array.from({ length: n }).map((_, i) => (
      <div key={i} style={{ animationDelay: `${i * 70}ms` }}>
        <Skel className="aspect-[9/16] rounded-3xl" />
        <Skel className="h-3 w-2/3 mt-3" />
        <Skel className="h-6 w-1/2 mt-2 rounded-full" />
      </div>
    ))}
  </div>
);

export const PublicSkeleton = ({ testid = "page-skeleton" }) => (
  <div className="min-h-screen bg-[#04050a]" data-testid={testid}>
    <LandingNav />
    <main className="max-w-7xl mx-auto px-5 sm:px-8 pt-32 pb-20">
      <Skel className="h-3 w-32" />
      <Skel className="h-12 w-2/3 max-w-xl mt-4" />
      <Skel className="h-4 w-1/2 max-w-md mt-4" />
      <Skel className="h-48 w-full mt-10 rounded-3xl" />
      <GridSkeleton n={4} />
    </main>
  </div>
);
